<div class="header-sidebar-wrapper" [class.collapsed]="isCollapsed">
  <div class="sidebar-top">
    <!-- Header Row -->
    <div class="sidebar-header-row d-flex align-items-center justify-content-between p-1 my-2 mr-1 ml-2">
      <img
        *ngIf="isCollapsed"
        src="assets/images/svg/logo.svg"
        alt="Rappit Logo"
        class="rappit-logo cursor-pointer"
        height="24"
        (click)="toggleSidebar()"
        (keydown.enter)="toggleSidebar()"
        tabindex="0"
      />
      <rt-product-logo
        width="75"
        height="33"
        class="cursor-pointer"
        tabindex="0"
        *ngIf="!isCollapsed"
        alt="Rappit Logo"
      ></rt-product-logo>

      <a
        class="toggle-side-menu cursor-pointer"
        [ngClass]="{ 'ml-auto': !isCollapsed, 'm-auto': isCollapsed }"
        (click)="toggleSidebar()"
        *ngIf="!isCollapsed"
        (keydown.enter)="toggleSidebar()"
        tabindex="0"
      >
        <svg-icon
          [src]="'assets/designIconLib/SVG/layout-left.svg'"
          [svgStyle]="{ 'width.px': 20, 'height.px': 20 }"
        ></svg-icon>
      </a>
    </div>

    <!-- Main Menu -->
    <ul class="sidebar-menu main-menu">
      <!-- Organization selector -->
      <div class="d-inline-block dropdown orgSelection w-100 px-2 py-2" *ngIf="!isCollapsed">
        <p-select
          *ngIf="userOrgs && userOrgs.length > 1"
          [options]="orgs"
          #dropdownEle1
          (onShow)="onDropdownShow()"
          (onHide)="orgDropdownHidden()"
          [styleClass]="'appname-dropdown w-100'"
          [(ngModel)]="selectedOrg"
          [disabled]="userOrgs.length === 1"
          optionLabel="name"
          [filter]="true"
          filterBy="name"
          [filterValue]="searchTextOrg"
          placeholder="Select an Organization"
          (onChange)="handleOrgSelectionChange($event)"
          (onFilter)="searchOrg($event)"
          showDelay="100"
          hideDelay="100"
          pTooltip="Organization Name"
          tooltipStyleClass="label-tooltip"
          tooltipPosition="bottom"
          appendTo="body"
          panelStyleClass="header-dropdown-panel"
        >
          <ng-template pTemplate="selectedItem">
            <div class="item-value" *ngIf="selectedOrg">
              <div class="text-truncate">{{ selectedOrg.name }}</div>
            </div>
          </ng-template>
          <ng-template let-item pTemplate="item">
            <div [pTooltip]="item.name">{{ item.name }}</div>
          </ng-template>
          <ng-template pTemplate="empty">
            <div class="loader-container" *ngIf="headerLoader">
              <p-progress-spinner></p-progress-spinner>
            </div>
            <div *ngIf="headerEmpMsg" class="emptyMsgContainer">
              {{ 'NO_RECORDS_FOUND' | translate }}
            </div>
          </ng-template>
        </p-select>

        <span
          class="app_org_name d-block text-truncate"
          *ngIf="userOrgs && userOrgs.length === 1"
          showDelay="100"
          hideDelay="100"
          pTooltip="Organization Name"
          tooltipStyleClass="label-tooltip"
          tooltipPosition="bottom"
        >
          {{ selectedOrg?.name }}
        </span>
      </div>

      <li
        class="menu-item"
        [class.active]="activeMenu === 'home'"
        (click)="activeMenu = 'home'"
        (keydown.enter)="activeMenu = 'home'"
        tabindex="0"
      >
        <a
          (click)="navigateToHome()"
          (keydown.enter)="navigateToHome()"
          tabindex="0"
          class="d-flex align-items-center"
          [class.justify-content-center]="isCollapsed"
          [title]="isCollapsed ? ('HOME' | translate) : ''"
        >
          <svg-icon
            [src]="'assets/designIconLib/SVG/grid-01.svg'"
            [svgStyle]="{ 'width.px': 18, 'height.px': 18 }"
          ></svg-icon>
          <span class="ml-1" [class.d-none]="isCollapsed">{{ 'HOME' | translate }}</span>
        </a>
      </li>

      <li
        class="menu-item"
        [class.active]="activeMenu === 'agents'"
        (click)="activeMenu = 'agents'"
        (keydown.enter)="activeMenu = 'agents'"
        tabindex="0"
      >
        <a
          (click)="navigateToAgents()"
          (keydown.enter)="navigateToAgents()"
          tabindex="0"
          class="d-flex align-items-center"
          [class.justify-content-center]="isCollapsed"
          [title]="isCollapsed ? ('AGENTS' | translate) : ''"
        >
          <svg-icon
            [src]="'assets/designIconLib/SVG/cpu-chip-01.svg'"
            [svgStyle]="{ 'width.px': 18, 'height.px': 18 }"
          ></svg-icon>
          <span class="ml-1" [class.d-none]="isCollapsed">{{ 'AGENTS' | translate }}</span>
        </a>
      </li>

      <li class="menu-item" [class.active]="activeMenu === 'clouds-centre'">
        <a
          class="d-flex align-items-center"
          [class.justify-content-center]="isCollapsed"
          [title]="isCollapsed ? ('CLOUDS_CENTER' | translate) : ''"
          (click)="gotoCloudsCentre()"
          (keydown.enter)="gotoCloudsCentre()"
          tabindex="0"
        >
          <svg-icon
            [src]="'assets/designIconLib/SVG/cloud-01.svg'"
            [svgStyle]="{ 'width.px': 18, 'height.px': 18 }"
          ></svg-icon>
          <span class="ml-1" [class.d-none]="isCollapsed">{{ 'CLOUDS_CENTER' | translate }}</span>
        </a>
      </li>

      <li class="menu-item" [class.active]="activeMenu === 'subscription'">
        <a
          class="d-flex align-items-center"
          [class.justify-content-center]="isCollapsed"
          [title]="isCollapsed ? ('BILLING_AND_LICENSING' | translate) : ''"
          (click)="gotoSubscription()"
          (keydown.enter)="gotoSubscription()"
          tabindex="0"
        >
          <svg-icon
            [src]="'assets/designIconLib/SVG/bank-note-03.svg'"
            [svgStyle]="{ 'width.px': 18, 'height.px': 18 }"
          ></svg-icon>
          <span class="ml-1" [class.d-none]="isCollapsed">{{ 'BILLING_AND_LICENSING' | translate }}</span>
        </a>
      </li>
    </ul>

    <!-- Recent Apps -->
    <div class="sidebar-recent-section mt-4 pt-3" *ngIf="recentApps && recentApps.length > 0 && !isCollapsed">
      <span class="text-muted ml-3 text-uppercase font-size-xs font-weight-bold">Recents</span>
      <ul class="sidebar-menu recent-menu mt-2">
        <li class="menu-item" *ngFor="let app of recentApps">
          <a
            (click)="navigateToApp(app.id)"
            (keydown.enter)="navigateToApp(app.id)"
            tabindex="0"
            class="d-flex align-items-center text-truncate"
          >
            <span class="text-truncate">{{ app.name }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>

  <div class="sidebar-bottom p-1 pb-3 w-100">
    <!-- Footer Links -->
    <ul class="sidebar-menu footer-menu">
      <li class="menu-item">
        <a
          [href]="learnUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="d-flex align-items-center"
          [class.justify-content-center]="isCollapsed"
          [title]="isCollapsed ? ('LEARN' | translate) : ''"
        >
          <svg-icon
            [src]="'assets/designIconLib/SVG/lightbulb-05.svg'"
            [svgStyle]="{ 'width.px': 18, 'height.px': 18 }"
          ></svg-icon>
          <span class="ml-1" [class.d-none]="isCollapsed">{{ 'LEARN' | translate }}</span>
        </a>
      </li>
      <li class="menu-item">
        <a
          [href]="documentationUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="d-flex align-items-center"
          [class.justify-content-center]="isCollapsed"
          [title]="isCollapsed ? ('DOCUMENTATION' | translate) : ''"
        >
          <svg-icon
            [src]="'assets/designIconLib/SVG/book-open-02.svg'"
            [svgStyle]="{ 'width.px': 18, 'height.px': 18 }"
          ></svg-icon>
          <span class="ml-1" [class.d-none]="isCollapsed">{{ 'DOCUMENTATION' | translate }}</span>
        </a>
      </li>
    </ul>

    <!-- User Profile Flyout -->
    <div class="position-relative w-100 user-flyout-anchor">
      <div
        class="user-profile-menu-container d-flex align-items-center p-2 mt-1 rounded cursor-pointer"
        [class.justify-content-center]="isCollapsed"
        (click)="menu.toggle($event)"
        (keydown.enter)="menu.toggle($event)"
        tabindex="0"
      >
        <p-avatar
          class="user-avatar-icon flex-shrink-0"
          [label]="avatarImage?.character"
          shape="circle"
          [style]="{ 'background-color': avatarImage?.color }"
        >
        </p-avatar>
        <div class="user-details ml-2 overflow-hidden flex-grow-1" [class.d-none]="isCollapsed">
          <div class="user-name text-truncate" [title]="loggedInUser">{{ loggedInUser }}</div>
          <div class="user-email small text-truncate" [title]="userEmail">{{ userEmail }}</div>
        </div>
      </div>
      <p-menu
        #menu
        [model]="userMenuItems"
        [popup]="true"
        appendTo="body"
        styleClass="user-profile-menu right-aligned-popup"
      >
        <ng-template pTemplate="item" let-item>
          <a
            *ngIf="!item.separator"
            class="p-menu-item-link"
            [ngClass]="item.styleClass"
            (click)="menu.itemClick($event, item)"
            (keydown.enter)="menu.itemClick($event, item)"
            tabindex="0"
          >
            <span *ngIf="item.icon && !item.svgIcon" class="p-menu-item-icon" [ngClass]="item.icon"></span>
            <svg-icon
              *ngIf="item.svgIcon"
              class="p-menu-item-icon d-flex align-items-center"
              [src]="item.svgIcon"
              [svgStyle]="{ 'width.px': 18, 'height.px': 18 }"
            ></svg-icon>
            <span class="p-menu-item-label text-nowrap">{{ item.label }}</span>
          </a>
        </ng-template>
      </p-menu>
    </div>
  </div>
</div>
